import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAmbUMayZuYOGO7hIgYL1UbVUpzqAumDv0",
  authDomain: "adroxs-page.firebaseapp.com",
  projectId: "adroxs-page",
  storageBucket: "adroxs-page.firebasestorage.app",
  messagingSenderId: "622326195806",
  appId: "1:622326195806:web:20defe2234fbc52f4eb6cf",
  measurementId: "G-1QLZ8THY3K"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Storage
export const storage = getStorage(app);

export default app;
